import React, { Fragment } from "react";
import "./AdminDashBoard.css";
import StashDrop from "./StashDrop";
import Wavpools from "./Wavpools";
import User from "./User";
import Sales from "./Sales";
const AdminDashBoard = () => {
  console.log();
  if (window.location.href === "http://localhost:3001/admin") {
  }
  return (
    <Fragment>
      <div className="container-fluid">
        <StashDrop />
        <Wavpools />
        <User />
        <Sales />
      </div>
    </Fragment>
  );
};

export default AdminDashBoard;
